import { useState } from 'react';
import { toast } from 'react-hot-toast';
import { BaseModalProps, Button, ModalContentWrapper, TextInput } from 'ui';

interface CreateSecretModalProps extends BaseModalProps {
  vaultName: string;
  onCreate: (payload: { name: string; value: string }) => Promise<void>;
}

const CreateSecretModal = ({ open, onClose, onCreate, vaultName }: CreateSecretModalProps) => {
  const [name, setName] = useState('');
  const [value, setValue] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const resetAndClose = () => {
    setName('');
    setValue('');
    onClose();
  };

  const handleClose = () => {
    if (isSubmitting) return;
    resetAndClose();
  };

  const handleSubmit = async () => {
    if (!name.trim() || !value.trim()) {
      toast.error('Secret name and value are required');
      return;
    }

    setIsSubmitting(true);
    try {
      await onCreate({ name: name.trim(), value });
      resetAndClose();
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <ModalContentWrapper
      open={open}
      title={`Create Secret in ${vaultName}`}
      onClose={handleClose}
      variant="center"
      classes={{ dialogPanel: 'max-w-xl' }}
    >
      <div className="px-6 pb-6 pt-2 space-y-4">
        <TextInput
          name="secret_name"
          label="Secret name"
          value={name}
          onChange={e => setName(e.target.value)}
        />
        <TextInput
          name="secret_value"
          label="Secret value"
          textarea
          value={value}
          onChange={e => setValue(e.target.value)}
          className="min-h-[150px]"
        />
        <div className="flex justify-end gap-3 pt-2">
          <Button variant="secondary" onClick={handleClose} disabled={isSubmitting}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleSubmit} disabled={isSubmitting}>
            {isSubmitting ? 'Creating...' : 'Create secret'}
          </Button>
        </div>
      </div>
    </ModalContentWrapper>
  );
};

export default CreateSecretModal;
